var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9917 12.332C20.8179 17.2807 16.7433 21.0576 11.9284 20.9993C6.63177 20.9355 2.76846 16.5361 3.0108 11.5714C3.24938 6.68275 7.27706 2.93787 12.0797 3.00078C17.4355 3.07121 21.2011 7.50253 20.9917 12.332ZM10.0527 11.1535C10.342 10.9178 10.6275 10.6887 10.9074 10.453C11.2136 10.1957 11.2756 10.0023 11.1366 9.67547C10.8774 9.06415 10.6116 8.45566 10.3401 7.84904C10.1992 7.53446 9.99068 7.42178 9.66099 7.49408C9.08896 7.61897 8.51975 7.75607 7.95242 7.90069C7.61521 7.98614 7.48089 8.16831 7.49874 8.51294C7.5194 8.91015 7.54288 9.30924 7.60112 9.7027C7.88761 11.6381 8.7959 13.2372 10.2537 14.5284C11.7133 15.8205 13.4398 16.4319 15.3719 16.5089C15.8584 16.5286 16.0303 16.3971 16.1459 15.9182C16.2642 15.4252 16.3798 14.9313 16.4953 14.4373C16.593 14.0185 16.4915 13.8119 16.0942 13.6363C15.5372 13.3894 14.9774 13.1471 14.4194 12.9029C14.0043 12.7217 13.8352 12.7621 13.544 13.1142C13.312 13.3941 13.08 13.6748 12.8499 13.9528C11.61 13.318 10.6858 12.4062 10.0527 11.1535Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.0536fdae95351dd3aa3da52a106b99e5.svg";
export { ForwardRef as ReactComponent };